import { handleErrorAxios } from "@/common/lib/formatter";
import Http from "@/common/lib/http";

const actions = {
    async listStoresPaginated(
        { commit, dispatch },
        { complete, itemsByPage, page }
    ) {
        try {
            const { data } = await Http.instance.get("/bo/stores", {
                params: { complete, itemsByPage, page }
            });
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_STORES", parseError);
            throw parseError;
        }
    },
    async getStoreById({ commit, dispatch }, { id }) {
        try {
            const { data } = await Http.instance.get(`/bo/stores/${id}`);
            commit(
                "commons/UPDATE_MERCHANTS_GLOBAL",
                { ...data, merchantId: id, merchantType: "store" },
                { root: true }
            );
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_STORES", parseError);
            throw parseError;
        }
    },
    async getStoreOwnById({ commit, dispatch }, { id }) {
        try {
            const { data } = await Http.instance.get(`/bo/stores/own/${id}`);
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_STORES", parseError);
            throw parseError;
        }
    },
    async createStoreOwn(
        { commit, dispatch },
        {
            address,
            addressComplement,
            cityCode,
            coordinates,
            identificationNumber,
            identificationType,
            name,
            neighborhood,
            phone
        }
    ) {
        try {
            const { data } = await Http.instance.post("/bo/stores/own", {
                identificationNumber,
                identificationType,
                name,
                phone,
                address,
                coordinates,
                cityCode,
                neighborhood,
                addressComplement
            });
            commit("commons/SET_MERCHANTS_OWN", [data], { root: true });
            dispatch("auth/applyMerchantPermissions", data.permissions, {
                root: true
            });
            commit("commons/SET_MERCHANT_SELECTED", data, { root: true });
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_STORES", parseError);
            throw parseError;
        }
    },
    async updateStoreOwn(
        { commit, dispatch },
        {
            address,
            addressComplement,
            cityCode,
            coordinates,
            id,
            identificationNumber,
            identificationType,
            name,
            neighborhood,
            phone
        }
    ) {
        try {
            const { data } = await Http.instance.patch(`/bo/stores/own/${id}`, {
                identificationNumber,
                identificationType,
                name,
                phone,
                address,
                coordinates,
                cityCode,
                neighborhood,
                addressComplement
            });

            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_STORES", parseError);
            throw parseError;
        }
    },
    async createStore(
        { commit, dispatch },
        {
            address,
            addressComplement,
            cityCode,
            communicationConfig,
            content,
            coordinates,
            identificationNumber,
            identificationType,
            images,
            keywords,
            name,
            neighborhood,
            phone,
            slug,
            summary
        }
    ) {
        try {
            const { data } = await Http.instance.post("/bo/stores", {
                identificationNumber,
                identificationType,
                name,
                phone,
                slug,
                images,
                address,
                coordinates,
                cityCode,
                keywords,
                content,
                neighborhood,
                summary,
                addressComplement,
                communicationConfig
            });
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_STORES", parseError);
            throw parseError;
        }
    },
    async updateStore(
        { commit, dispatch },
        {
            address,
            addressComplement,
            cityCode,
            communicationConfig,
            content,
            coordinates,
            id,
            identificationNumber,
            identificationType,
            images,
            keywords,
            name,
            neighborhood,
            phone,
            slug,
            summary
        }
    ) {
        try {
            const { data } = await Http.instance.patch(`/bo/stores/${id}`, {
                identificationNumber,
                identificationType,
                name,
                phone,
                slug,
                images,
                address,
                coordinates,
                cityCode,
                keywords,
                content,
                communicationConfig,
                neighborhood,
                summary,
                addressComplement
            });

            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_STORES", parseError);
            throw parseError;
        }
    },
    async updateStoreMoney({ commit, dispatch }, { id, moneyConfig }) {
        try {
            const { data } = await Http.instance.put(`/bo/stores/${id}/money`, {
                moneyConfig
            });
            commit(
                "commons/UPDATE_MERCHANTS_GLOBAL",
                { merchantId: id, merchantType: "store", moneyConfig },
                { root: true }
            );
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_STORES", parseError);
            throw parseError;
        }
    },
    async updateStoreServices({ commit, dispatch }, { id, services }) {
        try {
            const { data } = await Http.instance.put(
                `/bo/stores/${id}/services`,
                {
                    services
                }
            );
            commit(
                "commons/UPDATE_MERCHANTS_GLOBAL",
                { merchantId: id, merchantType: "store", services },
                { root: true }
            );
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_STORES", parseError);
            throw parseError;
        }
    },
    async setStoreActive(
        { commit, dispatch },
        { enabledForDeliveries, id, weight }
    ) {
        try {
            const { data } = await Http.instance.put(
                `/bo/stores/${id}/active`,
                {
                    enabledForDeliveries,
                    weight
                }
            );
            commit(
                "commons/UPDATE_MERCHANTS_GLOBAL",
                {
                    merchantId: id,
                    merchantType: "store",
                    enabledForDeliveries,
                    weight
                },
                { root: true }
            );
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_STORES", parseError);
            throw parseError;
        }
    },
    async transferStore({ commit, dispatch }, { id, isOwn }) {
        try {
            const { data } = await Http.instance.put(
                `/bo/stores/${id}/transfer`,
                {
                    isOwn
                }
            );
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_STORES", parseError);
            throw parseError;
        }
    },
    async deleteStore({ commit, dispatch }, { id }) {
        try {
            await Http.instance.delete(`/bo/stores/${id}`);
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_STORES", parseError);
            throw parseError;
        }
    },
    async deleteStoreDefinitively({ commit, dispatch }, { id }) {
        try {
            await Http.instance.delete(`/bo/stores/${id}/definitive`);
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_STORES", parseError);
            throw parseError;
        }
    }
};

export default actions;
